import styled from 'styled-components'
import { Theme } from '../../Theme';

const Wrapper = styled.div`
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
`;

const BackgroundVideo = styled.video`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    object-fit: cover;
    z-index: 1;
`;

const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    z-index: 2;
`;

const CenterBox = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 3;
`;

const HomeIcon = styled.img`
    position: absolute;
    top: 24px;
    left: 24px;
    width: 28px;
    height: 28px;
    cursor: pointer;
    z-index: 4;
`;

const Card = styled.div`
    // branco com trasparencia 
    background: rgba(255, 255, 255, 0.70);
    border-radius: 18px;
    padding: 36px 20px 24px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
    width: 600px;
`;

const CertificadoIcon = styled.img`
    width:200px;
    margin-bottom: 12px;
`;

const Title = styled.h2`
    color: #fff;
    font-size: 2.2rem;
    font-weight: 400;
    margin: 0;
    text-align: center;
`;

const Premium = styled.span`
    color: #fff;
    font-size: 2.8rem;
    font-weight: 700;
    margin-left: 8px;
    letter-spacing: 1px;
    font-style: italic;
`;

const InputBox = styled.div`
    margin-top: 24px;
    display: flex;
    align-items: center;
    background: rgba(0,0,0,0.80);
    border-radius: 8px;
    width: 100%;
`;

const Input = styled.input`
    background: transparent;
    border: none;
    color: #fff;
    font-size: 1.1rem;
    padding: 12px 5px;
    outline: none;
    width: 90%;
    &::placeholder {
        color: #e0e0e0;
        opacity: 1;
    }
`;

const SearchButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-left: 20px;
`;

const SearchIcon = styled.img`
    width: 28px;
    height: 28px;
`;

export const Styled = {
    Wrapper,
    BackgroundVideo,
    Overlay,
    CenterBox,
    HomeIcon,
    Card,
    CertificadoIcon,
    Title,
    Premium,
    InputBox,
    Input,
    SearchButton,
    SearchIcon
}